import { For, Show, type JSX } from "solid-js";

export interface LigneBarre {
  libelle: JSX.Element;
  /** Texte complet, en infobulle. */
  titre?: string;
  valeur: number;
  /** Ce qui s'écrit à droite : l'effectif en clair tient lieu de vue tableau. */
  texte: string;
  /** Indicateur dérivé : en retrait, marqué ∑. */
  indicateur?: boolean;
}

/** Barres horizontales d'une seule série, donc d'une seule teinte. */
export function Barres(props: {
  lignes: LigneBarre[];
  max: number;
  couleur?: string;
  larges?: boolean;
}) {
  return (
    <div class="barres" classList={{ "barres-larges": props.larges ?? false }}>
      <For each={props.lignes}>
        {(l) => (
          <div class="barre-ligne" title={l.titre}>
            <span class="barre-intitule" classList={{ "est-indicateur": l.indicateur ?? false }}>
              {l.libelle}
              <Show when={l.indicateur}>
                <span
                  class="marque-indicateur"
                  title="Indicateur dérivé : résume les autres colonnes, ce n'est pas une famille de leviers."
                >
                  {" "}
                  ∑
                </span>
              </Show>
            </span>
            <span class="barre-piste" aria-hidden="true">
              <span
                class="barre-valeur"
                style={{
                  width: `${props.max > 0 ? (100 * l.valeur) / props.max : 0}%`,
                  background: props.couleur,
                }}
              />
            </span>
            <span class="barre-nombre">{l.texte}</span>
          </div>
        )}
      </For>
    </div>
  );
}
